import React from "react";

const GraphOrangeSquare = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EA580C" fillOpacity="0.1" />
      <path
        d="M24 28V33"
        stroke="#EA580C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 26V33"
        stroke="#EA580C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 22V33"
        stroke="#EA580C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.0001 15L25.3541 23.646C25.3077 23.6926 25.2525 23.7295 25.1918 23.7547C25.131 23.7799 25.0659 23.7929 25.0001 23.7929C24.9344 23.7929 24.8692 23.7799 24.8085 23.7547C24.7477 23.7295 24.6926 23.6926 24.6461 23.646L21.3541 20.354C21.2604 20.2603 21.1332 20.2076 21.0006 20.2076C20.868 20.2076 20.7409 20.2603 20.6471 20.354L14.0001 27"
        stroke="#EA580C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9999 30V33"
        stroke="#EA580C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 26V33"
        stroke="#EA580C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GraphOrangeSquare;
